module.exports = __webpack_public_path__ + "img/mx.4f3f3af4.svg";